export enum RiskLevel {
    Low = 'l',
    Middle = 'm',
    Hight = 'h',
}
